import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'

const VideoQuizQuestionsFormView = ({ children, classes }) => {
  return <div className={classes.wrapper}>{children}</div>
}

export default injectStyles(styles)(VideoQuizQuestionsFormView)
